import PageTitle from "../../comman/page-title"

const NotFoundComponent = () => {
  return (
    <>
      <PageTitle title="Page Not Found" description="The page you are looking for does not exist." />
      <div id="error_page">
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-xl-7 col-lg-9">
              <h2 style={{ fontSize: "150px" }}>404</h2>
              <p>We're sorry, but the page you were looking for doesn't exist.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NotFoundComponent